import script from "./_wof-campaign.vue?vue&type=script&setup=true&lang=ts"
export * from "./_wof-campaign.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__